var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 2.875h3.167a1.584 1.584 0 011.583 1.583v11.084a1.584 1.584 0 01-1.583 1.583h-3.167M6.333 6.042L2.375 10l3.958 3.958M2.375 10h9.5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTkgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS44NzUgMi44NzVMMTUuMDQxNyAyLjg3NUMxNS40NjE2IDIuODc1IDE1Ljg2NDMgMy4wNDE4MSAxNi4xNjEzIDMuMzM4NzVDMTYuNDU4MiAzLjYzNTY4IDE2LjYyNSA0LjAzODQxIDE2LjYyNSA0LjQ1ODMzTDE2LjYyNSAxNS41NDE3QzE2LjYyNSAxNS45NjE2IDE2LjQ1ODIgMTYuMzY0MyAxNi4xNjEzIDE2LjY2MTNDMTUuODY0MyAxNi45NTgyIDE1LjQ2MTYgMTcuMTI1IDE1LjA0MTcgMTcuMTI1TDExLjg3NSAxNy4xMjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuMzMzMjUgNi4wNDE3MUwyLjM3NDkyIDEwTDYuMzMzMjUgMTMuOTU4NCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi4zNzUgMTBMMTEuODc1IDEwIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgLogout as ReactComponent };